module.exports = __webpack_public_path__ + "media/assets/icons/facebookIcon-e0a74ab3f0ed2a62a20b9a58fda6382c.png";